import {
  ActivityDataFragment,
  AutofillSource,
} from '../../../../generated/graphql';

export type LibraryFormAssessment = Extract<
  ActivityDataFragment,
  { __typename?: 'ActivityAssessment' }
>['assessment'];

export type LibraryFormQuestion = LibraryFormAssessment['questions'][number];

export const getQuestionText = (question: LibraryFormQuestion): string =>
  'question' in question && typeof question.question === 'string'
    ? question.question
    : '';

export const isQuestionRequired = (question: LibraryFormQuestion): boolean =>
  'isRequired' in question && question.isRequired === true;

export const getAutofillSourceLabel = (
  autofillSource: AutofillSource,
): string => {
  switch (autofillSource) {
    case AutofillSource.FullName:
      return 'Full name';
    case AutofillSource.Email:
      return 'Email';
    case AutofillSource.PhoneNumber:
      return 'Phone number';
    case AutofillSource.AddressStreet:
      return 'Street address';
    case AutofillSource.AddressCity:
      return 'City';
    case AutofillSource.AddressState:
      return 'State';
    case AutofillSource.AddressPostalCode:
      return 'Postal code';
    case AutofillSource.AddressCountry:
      return 'Country';
    case AutofillSource.DateOfBirth:
      return 'Date of birth';
    case AutofillSource.PreferredLanguage:
      return 'Preferred language';
    case AutofillSource.Timezone:
      return 'Timezone';
    case AutofillSource.PractitionerName:
      return 'Practitioner name';
    case AutofillSource.PractitionerRole:
      return 'Practitioner role';
    case AutofillSource.ParticipantId:
      return 'Participant ID';
    default:
      return 'Response';
  }
};
